/**
 * Load and process media data from JSON files
 * Uses pre-generated mediaManifest.json (created at build time)
 * and enriches with metadata from mediaData.json
 * 
 * @returns Promise that resolves to processed media data
 */
const loadMediaData = async () => {
  try {
    // Fetch both JSON files in parallel
    const [manifestResponse, metadataResponse] = await Promise.all([
      fetch('/mediaManifest.json'),
      fetch('/mediaData.json')
    ]);

    if (!manifestResponse.ok) {
      throw new Error(`Failed to load mediaManifest.json: ${manifestResponse.status}`);
    }
    if (!metadataResponse.ok) {
      throw new Error(`Failed to load mediaData.json: ${metadataResponse.status}`);
    }

    const filesByYear = await manifestResponse.json();
    const metadata = await metadataResponse.json();

    // Merge file lists with metadata
    const processedData = {};
    
    Object.entries(metadata).forEach(([year, yearData]) => {
      const files = filesByYear[year] || [];
      
      // Only include years that have files
      if (files.length > 0) {
        processedData[year] = {
          title: yearData.title,
          description: yearData.description,
          files: files
        };
      }
    });

    return processedData;
  } catch (error) {
    console.error('Error loading media data:', error);
    return {};
  }
};

export { loadMediaData };
export default loadMediaData;